import { http } from '../core/http';

/**
 * 注册账号
 * @export
 * @param {Object} params - 
 * @param {Object} params.name - 用户名
 * @param {Object} params.password - 密码
 * @returns
 */
export async function register(params: any) {
  return await http.post('/user/create', params);
}


/**
 * 账号登录
 * @export
 * @param {Object} params - 
 * @param {string} params.name - 用户名
 * @param {string} params.password - 密码
 * @returns
 */
export async function login(params: any) {
  // return await http.post('/api/Api/login', params);
  return await http.post('/index.php?route=vapi/account/login', params)
}

/**
 * 账号登出
 */
export async function login_out({ token = '' }) {
  // return await http.post('/api/member/logout',{token});
  return await http.post('/index.php?route=vapi/account/logout', { token });
}


/**
 * 获取用户信息
 * @export
 * @param {Object} params - 
 * @param {string} [params.userId] - 用户id
 * @returns
 */
export async function userInfo(params: any) {
  // return await http.post('/api/member/userinfo', params);
  return await http.post('/index.php?route=vapi/user/userinfo', params);

}

/**
 * 获取个人详细资料
 * @export
 * @param {Object} params - 
 * @param {string} [params.userId] - 用户id
 * @returns
 */
export async function userDetail(params: any) {
  // return await http.post('/api/member/userdetail', params);
  return await http.post('/index.php?route=vapi/user/userdetail', params);
}

/**
* 修改用户信息
* @export
* @param {Object} [params] - 
* @param {string} [params.name] - product user step
* @param {string} [params.avatar] - product user step
* @param {string} [params.sign] - product user step
* @returns
*/
export async function userEdit(params: any) {
  return await http.post('/user/edit', params);
}

/**
 * 子账户列表
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getChildAccount({ page = 1 } = {}): Promise<any> {
  // return await http.post('/api/member/childaccount',{page})
  return await http.post('/index.php?route=vapi/user/childrenAccountList', { page })
}

/**
 * 创建子账户
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addChildAccount({ uname = '', pwd = '', remarks = '' } = {}): Promise<any> {
  return await http.post('/api/member/childaccount_update', { uname, pwd, remarks })
}

/**
 * 删除子账户
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function delChildAccount({ did = '' } = {}): Promise<any> {
  return await http.post('/api/member/childaccount_del', { did })
}

/**
 * 编辑子账户
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function editChildAccount({ saveid = '', pwd = '', remarks = '' } = {}): Promise<any> {
  return await http.post('/api/member/childaccount_edit', { saveid, pwd, remarks })
}

/**
 * 登录日志
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function loginLog({ page = 1 } = {}): Promise<any> {
  // return await http.post('/api/member/loginlog',{page})
  return await http.post('/index.php?route=vapi/user/loginLog', { page })
}

/**
 * 实名信息
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function getAuthenticationInfo(): Promise<any> {
  return await http.post('/api/member/authentication')
}

/**
 * 个人实名
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addSaveInfo({ username = '', card_id = '' }): Promise<any> {
  return await http.post('/api/member/saveinfo', { username, card_id })
}

/**
 * 企业实名
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addEnterpriseSaveInfo({ enterprise_name = '', enterprise_code = '', corporate_tel = '', imgs = '' }): Promise<any> {
  return await http.post('/api/member/save_enterprise', { enterprise_name, enterprise_code, corporate_tel, imgs })
}

/**
 * 企业实名上传营业执照
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function addEnterpriseSaveUploadimg({ file = '' }): Promise<any> {
  return await http.post('/index/member/uploadimg', file)
}

/**
* 购物车-检测登录
* @export
* @param {Object} [params] - 
* @returns
*/
export async function checkIsLogin(): Promise<any> {
  return await http.post('/index/index/checkislogin');
}
